module.exports = __webpack_public_path__ + "img/logo-gie-full.76797d19.png";